import { Post } from "../Request/Api";
export default {
  state: {
    setdialog: false,
  },
  getters: {
    getdialog(state: any) {
      return state.setdialog;
    },
  },
  actions: {
    ToggleContact({ commit }: any, payload: boolean) {
      commit("togglecontact", payload);
    },
    async ContactUs({ commit }: any, payload: any) {
      return await Post("Contact/ContactResponse", payload).then((res: any) => {
        return res.data;
      });
    },
  },
  mutations: {
    togglecontact(state: any, payload: any) {
      state.setdialog = payload;
    },
  },
};
